module.exports = __webpack_public_path__ + "img/close.ba4396cf.svg";